export default "__VITE_ASSET__BrmKt0dn__"